
import { defineComponent, onBeforeMount, ref } from 'vue';
import axios, { AxiosError } from 'axios';
// eslint-disable-next-line
import { invokeSkillSync, invokeTemplateSeed, invokeCacheSync, invokeseedDefaultProgram } from '@/utils/admin/master_service';
// eslint-disable-next-line
import { invokeseedRoles } from '@/utils/admin/master_service';
// eslint-disable-next-line
import { invokeSeedProxyReviewers, invokeSeedUser, invokeDiffAccess, invokemigrateCohort, invokeMigrateCohortLA } from '@/utils/admin/master_service';
// eslint-disable-next-line
import { invokeMigrateCohortReview, invokeS2TasksMigration, invokeS2LAImport, invokeS2LAMigration, invokeMigrateS3Task } from '@/utils/admin/master_service';
// eslint-disable-next-line
import { invokeMigrateS3LA, invokeMigrateS3Review, invokeMigrateCohortProgram, invokeProxyReviewSeed, invokeGetUserRole } from '@/utils/admin/master_service';
// eslint-disable-next-line
import { invokeseedMaster, removeDuplicateProxyLearner, updateS3CohortsLearnerModifiedDate, invokeofcon, importLSS } from '@/utils/admin/master_service';
// eslint-disable-next-line
// eslint-disable-next-line
import { importEnvaccess } from '@/utils/admin/master_service';
import { getPreSignedUrl } from '@/utils/learner_submit_service';
import { uploadBulkParticipants, uploadEnvAccessUsers, uploadServiceLineSkillsGFEventID } from '@/utils/admin/program_administration_service';

export default defineComponent({
  setup() {
    const userRole = ref();
    const showScreen = ref(true);
    const showImportLSS = ref(false);
    const showEnvAccess = ref(false);
    const showServiceLineSkills = ref(false);
    const successMessage = ref();
    const errorMessage = ref();
    const file = ref();
    const fileName = ref();
    const preSignedUrl = ref();
    const renderReady = ref(true);
    const renderReady1 = ref(true);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const selectedFile = async (event: any) => {
      try {
        // eslint-disable-next-line prefer-destructuring
        const uploadedFile = event.target.files[0];
        const uploadedFileName = event.target.files[0].name;
        const isFileCSV = uploadedFileName.endsWith('.csv');
        if (!isFileCSV) {
          errorMessage.value = 'Please Select valid file to upload, only CSV file is allowed';
          setTimeout(() => {
            errorMessage.value = null;
          }, 6000);
          file.value = null;
          fileName.value = null;
        } else {
          file.value = uploadedFile;
          fileName.value = uploadedFileName;
        }
      } catch (error) {
        console.log(error);
      }
    };
    const uploadLSSLearners = async () => {
      renderReady1.value = false;
      if (!fileName.value) {
        errorMessage.value = 'Please Select valid file to upload';
        setTimeout(() => {
          errorMessage.value = null;
        }, 6000);
      } else {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const preSignedRes: any = await getPreSignedUrl('/v1/pretAuthUrlForUpload', {
          folder_name: 'lss_import',
          key_name: fileName.value,
        });
        preSignedUrl.value = preSignedRes.data.preSignedUrl;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const uploadedRes: any = await uploadBulkParticipants(preSignedUrl.value, file.value);
        if (uploadedRes.status === 200) {
          // const data = { fileKey: `lss_import/${fileName.value}` };
          const importList = await importLSS({ file_key: `lss_import/${fileName.value}` });
          console.log(importList);
          successMessage.value = 'LSS Record added';
          file.value = null;
          fileName.value = null;
          setTimeout(() => {
            successMessage.value = null;
            showImportLSS.value = false;
          }, 6000);
        }
      }
      renderReady1.value = true;
    };
    const uploadEnvAccessLearners = async () => {
      renderReady1.value = false;
      if (!fileName.value) {
        errorMessage.value = 'Please Select valid file to upload';
        setTimeout(() => {
          errorMessage.value = null;
        }, 6000);
      } else {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const preSignedRes: any = await getPreSignedUrl('/v1/pretAuthUrlForUpload', {
          folder_name: 'Env_Learner_access',
          key_name: fileName.value,
        });
        preSignedUrl.value = preSignedRes.data.preSignedUrl;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const uploadedRes: any = await uploadEnvAccessUsers(preSignedUrl.value, file.value);
        if (uploadedRes.status === 200) {
          console.log(' upload success');
          // const data = { fileKey: `Env_Learner_access/${fileName.value}` };
          const importList = await importEnvaccess({ file_key: `Env_Learner_access/${fileName.value}` });
          console.log(importList);
          successMessage.value = 'Learner Record added';
          file.value = null;
          fileName.value = null;
          setTimeout(() => {
            successMessage.value = null;
            showEnvAccess.value = false;
          }, 6000);
        }
      }
      renderReady1.value = true;
    };
    const uploadServiceLineSkillsGFEventIDs = async () => {
      renderReady1.value = false;
      if (!fileName.value) {
        errorMessage.value = 'Please Select valid file to upload';
        setTimeout(() => {
          errorMessage.value = null;
        }, 6000);
      } else {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const preSignedRes: any = await getPreSignedUrl('/v1/pretAuthUrlForUpload', {
          folder_name: 'service_line_skills',
          key_name: fileName.value,
        });
        preSignedUrl.value = preSignedRes.data.preSignedUrl;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const uploadedRes: any = await uploadServiceLineSkillsGFEventID(preSignedUrl.value, file.value);
        if (uploadedRes.status === 200) {
          console.log(' upload success');
          // const importList = await importServiceLineSkills({ file_key: `Service_line_skills_GF_Event_ID/${fileName.value}` });
          // console.log(importList);
          successMessage.value = 'File added';
          file.value = null;
          fileName.value = null;
          setTimeout(() => {
            successMessage.value = null;
            showEnvAccess.value = false;
          }, 6000);
        }
      }
      renderReady1.value = true;
    };
    const seedMaster = async () => {
      await invokeseedMaster('/admin/seedMasters');
    };

    const skillSync = async () => {
      await invokeSkillSync('/skill/sync');
    };
    const templateSeed = async () => {
      await invokeTemplateSeed('/email/template/seed');
    };
    const cacheSync = async () => {
      await invokeCacheSync('/cache/sync');
    };
    const seedDefaultProgram = async () => {
      await invokeseedDefaultProgram('/program/seedDefault');
    };
    const seedRoles = async () => {
      await invokeseedRoles('/role/init');
    };
    const seedProxyReviewers = async () => {
      await invokeSeedProxyReviewers('/user/proxy');
    };
    const seedUser = async () => {
      await invokeSeedUser('/user/seed');
    };
    const proxyReviewSeed = async () => {
      await invokeProxyReviewSeed('user/proxy');
    };
    const diffAccess = async () => {
      await invokeDiffAccess('/user/diff-access?isManualTrigger=true');
    };
    const triggerofcon = async () => {
      await invokeofcon('/admin/user/ofcon');
    };
    const migrateCohortProgram = async () => {
      await invokeMigrateCohortProgram('/migrate/cohort/program');
    };
    const migrateCohort = async () => {
      await invokemigrateCohort('/migrate/cohort');
    };
    const migrateCohortLA = async () => {
      await invokeMigrateCohortLA('/migration/cohort/trigger/learner_activity');
    };
    const migrateCohortReview = async () => {
      await invokeMigrateCohortReview('migration/cohort/trigger/review');
    };
    const migrateS2Tasks = async () => {
      await invokeS2TasksMigration('/migration/S2/tasks');
    };
    const triggerS2LAImport = async () => {
      await invokeS2LAImport('/migration/S2/learner_activity/import');
    };
    const triggerS2LAMigrate = async () => {
      await invokeS2LAMigration('/migration/S2/learner_activity/trigger');
    };
    const migrateS3Tasks = async () => {
      await invokeMigrateS3Task('migration/S3/task');
    };
    const migrateS3LA = async () => {
      await invokeMigrateS3LA('migration/S3/learner_activites/trigger');
    };
    const triggerS3Reviews = async () => {
      await invokeMigrateS3Review('migration/S3/learner_reviews/trigger');
    };
    const removeDuplicateProxyAssigned = async () => {
      try {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const res: any = removeDuplicateProxyLearner('learner/proxy/remove');
        console.log(`res data message ${res.data.message}`);
      } catch (error) {
        console.log('axios.isAxiosError(error)', axios.isAxiosError(error));
        if (axios.isAxiosError(error)) {
          const err = error as AxiosError;
          console.log(`err.response?.data ${err.response?.data}`);
          // console.log(`1 error getting prework details ${error}`);
        }
      }
    };
    const updateS3CohortsModifiedDate = async () => {
      try {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const res: any = updateS3CohortsLearnerModifiedDate('/updateCohortLearnerModifiedDate');
        console.log(`res data message ${res.data.message}`);
      } catch (error) {
        console.log('axios.isAxiosError(error)', axios.isAxiosError(error));
        if (axios.isAxiosError(error)) {
          const err = error as AxiosError;
          console.log(`err.response?.data ${err.response?.data}`);
          // console.log(`1 error getting prework details ${error}`);
        }
      }
    };
    // const masterSeed = async () => {
    //   await invokeMasterSeed('/admin/seedMasters');
    // };

    onBeforeMount(async () => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const role: any = await invokeGetUserRole('/getUserRole');
      userRole.value = role.user_roles;
      if (userRole.value.length > 0) {
        if (userRole.value.includes('System Admin')) {
          showScreen.value = true;
        } else {
          showScreen.value = false;
        }
      }
    });
    return {
      skillSync,
      templateSeed,
      cacheSync,
      seedDefaultProgram,
      seedRoles,
      seedProxyReviewers,
      diffAccess,
      migrateCohortProgram,
      migrateCohort,
      seedUser,
      proxyReviewSeed,
      migrateCohortLA,
      migrateCohortReview,
      migrateS2Tasks,
      triggerS2LAImport,
      triggerS2LAMigrate,
      migrateS3Tasks,
      migrateS3LA,
      triggerS3Reviews,
      seedMaster,
      showScreen,
      removeDuplicateProxyAssigned,
      updateS3CohortsModifiedDate,
      triggerofcon,
      showImportLSS,
      showEnvAccess,
      showServiceLineSkills,
      uploadLSSLearners,
      uploadEnvAccessLearners,
      uploadServiceLineSkillsGFEventIDs,
      selectedFile,
      successMessage,
      errorMessage,
      renderReady,
      renderReady1,
    };
  },
});
